/**
 * The footer's aggregation picker (spec M1-B4 §5.5, `[B5§6.3]`).
 *
 * The options are the column type's own `aggregations`, first one is the default; the list is
 * never hard-coded here (CLAUDE.md rule 6). `hide_footer` columns never reach this menu.
 */
import { findColumnType, type ColumnId } from '@elizmonday/shared';
import { useTable, useTableActions } from '../context';
import { AGGREGATION_LABELS, defaultAggregation } from '../summaries';
import { Menu, type MenuEntry } from './Menu';

export function SummaryMenu({ columnId, x, y }: { columnId: ColumnId; x: number; y: number }) {
  const payload = useTable((state) => state.payload);
  const actions = useTableActions();
  const column = payload?.columns.find((entry) => entry.id === columnId);
  if (!column) return null;
  const current = defaultAggregation(column);

  const entries: MenuEntry[] = (findColumnType(column.type)?.aggregations ?? []).map((aggregation) => ({
    id: aggregation,
    label: `${AGGREGATION_LABELS[aggregation] ?? aggregation}${aggregation === current ? ' ✓' : ''}`,
    onSelect: () => void actions.setAggregation(columnId, aggregation),
  }));

  return (
    <Menu
      entries={entries}
      x={x}
      y={y}
      width={180}
      label={`${column.title} summary`}
      onClose={() => actions.openMenu(null)}
    />
  );
}
